import React from 'react';
import Layout from '../../../../../components/mui/Layout';
import SearchComponent from './components/SearchComponent';
import TableComponent from './components/TableComponent';
import ModalComponent from './components/ModalComponent';

const PropertyTypePage = () => {
	
	return (
		<Layout.Page title="Tipos de Propiedades">
			<SearchComponent />
			
			<TableComponent />
			
			<ModalComponent />
		</Layout.Page>
	);
};

export default PropertyTypePage;
